import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/info/BackgroundInfoDetail.css";
// import ParliamentTabs from "../../components/info/ParliamentTabs";
import backgroundinfordetail_left_arrow from "../../assets/backgroundinfordetail_left_arrow.png";
import backgroundinfordetail_right_arrow from "../../assets/backgroundinfordetail_right_arrow.png";
import ParliamentCards from "../../components/info/ParliamentCards";
import parliamentLayout from "../../assets/backgroundinfo_background4.png";
import backgroundinfordetail_research from "../../assets/backgroundinfordetail_research.png";
import backgroundinfordetail_explain from "../../assets/backgroundinfordetail_explain.png";
import backgroundinfordetail_identify from "../../assets/backgroundinfordetail_identify.png";
import backgroundinfordetail_verify from "../../assets/backgroundinfordetail_verify.png";

const BackgroundInfoDetail = () => {
  // const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const slides = [
    // {
    //   id: 0,
    //   content: (
    //     <div className="slide-content-slide1">
    //       <h2>Why We Built This Website ?</h2>
    //       <div className="slide-columns">
    //         <div className="slide-box red">
    //           <h3>The Problem</h3>
    //           <ul>
    //             <li>76% Of Teens Get Political News From Social Media</li>
    //             <li>Political Misinformation Spreads 6x Faster Than Facts</li>
    //             <li>Only 24% Of Teens Verify Claims Before Sharing</li>
    //             <li>First-Time Voters Struggle To Find Reliable Sources</li>
    //           </ul>
    //         </div>
    //         <div className="slide-box blue">
    //           <h3>Our Solution</h3>
    //           <ul>
    //             <li>Create A Trusted Source Of Verified Political Facts</li>
    //             <li>Directly Link Claims To Parliamentary Records</li>
    //             <li>Teach Critical Thinking And Fact-Checking Skills</li>
    //             <li>Empower Young Australians To Make Informed Votes</li>
    //           </ul>
    //         </div>
    //       </div>
    //       <p className="quote">
    //         "Democracy Works Best When Voters Can Separate Fact From Fiction.
    //         We're Building The Tools To Make That Possible For The Next
    //         Generation."
    //       </p>
    //     </div>
    //   ),
    // },
    {
      id: 0,
      content: (
        <div className="slide-content-slide2">
          {/* <h2>Our Solution: Fact Checking</h2> */}
          <div className="slide-content-slide2-section1">
            <h3>How We Fact-Check Political Claims</h3>
            <p>
              How We Use Official Parliamentary Records To Verify What
              Politicians Actually Said And Did.
            </p>
          </div>
          <div className="fact-steps">
            {[
              {
                number: "1",
                image: backgroundinfordetail_identify,
                title: "IDENTIFY",
                text: "Spot claims that need verification from parliamentary discussions and public statements",
              },
              {
                number: "2",
                image: backgroundinfordetail_research,
                title: "RESEARCH",
                text: "Gather evidence from official records, verified sources, and parliamentary documentation",
              },
              {
                number: "3",
                image: backgroundinfordetail_verify,
                title: "VERIFY",
                text: "Cross-reference claims with multiple reliable sources to ensure accuracy",
              },
              {
                number: "4",
                image: backgroundinfordetail_explain,
                title: "EXPLAIN",
                text: "Present findings clearly with direct links to official sources",
              },
            ].map((step, idx) => (
              <div key={idx} className="fact-step">
                {/* <div className="circle-number">{step.number}</div> */}
                <img
                  src={step.image}
                  alt="backgroundinfordetail_identify"
                  className="fact-step-img"
                />
                <div className="step-title">{step.title}</div>
                <div className="fact-step-text">{step.text}</div>
              </div>
            ))}
          </div>

          <div className="why-it-matters">
            <h3>Why It Matters?</h3>
            <p>
              By checking facts against official records, we help you make
              informed voting decisions based on what politicians actually did —
              not just what people say they did.
            </p>
          </div>
        </div>
      ),
    },
    {
      id: 1,
      content: (
        <div className="slide-content-slide3">
          <h2>Practice Your Skills</h2>
          <p>
            Challenge yourself with our daily quiz and learn more about
            australian Politics and governance
          </p>
          <div className="challenge-columns">
            <div className="slide-content-slide3-challenge-box">
              <div className="challenge-header">Real Or Fake? Quiz</div>
              <div className="quote-box">
                <p>
                  Test your ability to identify true and false political claims
                  with our interactive quiz
                </p>
              </div>
              <div className="quiz-buttons">
                <button
                  className="btn-yellow"
                  onClick={() => navigate("/quiz")}
                >
                  Start Quiz
                </button>
              </div>
            </div>

            <div className="slide-content-slide3-challenge-box">
              <div
                className="challenge-header"
                onClick={() => navigate("/quiz")}
              >
                Scenario Challenge
              </div>
              <div className="quote-box">
                <p>
                  Learn practical fact-checking strategies through real-world
                  examples and interactive scenarios
                </p>
              </div>
              <div className="quiz-buttons">
                <button
                  className="btn-yellow"
                  onClick={() => navigate("/scenario")}
                >
                  Start scenario
                </button>
              </div>
            </div>
          </div>

          <div className="slide-content-slide3-footer">
            <p>
              Perfect For First-Time Voters And Students Learning About
              Australian Politics
            </p>
          </div>
        </div>
      ),
    },
    {
      id: 2,
      content: (
        <div className="background-section2">
          <div className="overlay-content-static">
            <h1>Why does Parliament even matter?</h1>
            <div className="vertical-spacer"></div>
            <p>
              Parliament is where laws that affect your daily life are made —
              like housing, jobs, uni fees, and climate action.
            </p>
            <ParliamentCards />
          </div>
        </div>
      ),
    },
    {
      id: 3,
      content: (
        <div className="transparency-section">
          <h2>How Do I Know Who’s Actually Doing A Good Job?</h2>
          <div className="transparency-content">
            <img
              src={parliamentLayout}
              alt="Parliament Layout"
              className="parliament-img"
            />

            <div className="transparency-info">
              <div className="transparency-item">
                <div>
                  <h3>🧾 Check how they voted: </h3>
                  <p>
                    Did Your MP Support Climate Action? Cheaper Uni? <br />
                    You Can Look Up How They Voted On Real Bills In Parliament.
                  </p>
                </div>
              </div>

              <div className="transparency-item">
                <div>
                  <h3>📢 Read their speeches: </h3>
                  <p>
                    What Did They Say In Parliament? You Can Search Debates And
                    Speeches <br />
                    Using Keywords Like “Housing” Or “Mental Health.”
                  </p>
                </div>
              </div>

              <button className="try-now-btn" onClick={() => navigate("/ask")}>
                Try now
              </button>
            </div>
            <p className="transparency-footer">
              Don’t Just Go By Headlines. <br />
              Go By Their Record. <br />
              Politicians Must Show What They Support — And It’s Public.
            </p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={currentIndex === 2 ? "root-with-bg" : "slide-container"}>
      <div
        className={
          currentIndex === 2 ? "root-with-bg-overlay-blur" : "slide-container"
        }
      >
        <button
          className="nav-button left"
          onClick={() => {
            if (currentIndex === 0) {
              navigate("/info"); // 👈 Navigate when on first slide
            } else {
              setCurrentIndex((prev) => prev - 1);
            }
          }}
        >
          <img
            src={backgroundinfordetail_left_arrow}
            alt="Previous"
            className="nav-arrow-icon"
          />
        </button>
        <div className="slide">{slides[currentIndex].content}</div>
        {currentIndex !== 3 && (
          <button
            className="nav-button right"
            onClick={() =>
              setCurrentIndex((prev) => (prev + 1) % slides.length)
            }
          >
            <img
              src={backgroundinfordetail_right_arrow}
              alt="Previous"
              className="nav-arrow-icon"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default BackgroundInfoDetail;